// extracted by mini-css-extract-plugin
export default {"container":"foodMenu_container__UvN2e","header":"foodMenu_header__MtGco","subtitle":"foodMenu_subtitle__fV6Jv","title":"foodMenu_title__3hXpu","masonry":"foodMenu_masonry__W7QW0"};